import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Performances } from './pages/Performances';
import { Lessons } from './pages/Lessons';
import { Workshops } from './pages/Workshops';
import { Repertoire } from './pages/Repertoire';
import { Media } from './pages/Media';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mndmw6trrmqu">
      <Routes data-id="element-1" data-mp="2mjzmh44o1nm1">
        <Route element={<Layout data-id="element-3" data-mp="31b8jvzet8d9q" />} data-id="element-2" data-mp="31aqeoda66opo">
          <Route index element={<Home data-id="element-5" data-mp="31c9ygdv1bhw7" />} data-id="element-4" data-mp="31bs09botatln" />
          <Route path="optreden" element={<Performances data-id="element-7" data-mp="2wjgrrkg09zhh" />} data-id="element-6" data-mp="31cjn9y4cfj0b" />
          <Route path="muziekles" element={<Lessons data-id="element-9" data-mp="2whxaprmizken" />} data-id="element-8" data-mp="2wj8ehrfz0s5r" />
          <Route path="workshops" element={<Workshops data-id="element-11" data-mp="28te3lff7pdo5" />} data-id="element-10" data-mp="28u5xmlt5v3cb" />
          <Route path="repertoire" element={<Repertoire data-id="element-13" data-mp="23vcm2yxfpmes" />} data-id="element-12" data-mp="28sl4n0mhvsgk" />
          <Route path="beeld" element={<Media data-id="element-15" data-mp="23ut9zyugts8o" />} data-id="element-14" data-mp="23w4ek0vqj40u" />
          <Route path="over-mij" element={<About data-id="element-17" data-mp="3ikh7o8icgqyg" />} data-id="element-16" data-mp="23ti8y6semyl9" />
          <Route path="contact" element={<Contact data-id="element-19" data-mp="3ijpdn24eb1aa" />} data-id="element-18" data-mp="3iiwfuqnezm4a" />
          <Route path="*" element={<NotFound data-id="element-21" data-mp="3ml17xky7saot" />} data-id="element-20" data-mp="3mljaezbgzl56" />
        </Route>
      </Routes>
    </BrowserRouter>;
}